import PhoneNumber from "@/model/interface/PhoneNumber";

export function isTollFree(phoneNumber: PhoneNumber): boolean {
  return phoneNumber.type === "TOLL_FREE";
}

export function isTollfreeVerified(phoneNumber: PhoneNumber): boolean {
  return phoneNumber.tollfreeVerificationStatus === "TWILIO_APPROVED";
}

export function isSmsSendable(phoneNumber: PhoneNumber, orgApproved: boolean): boolean {
  if (phoneNumber.a2pEnrollmentStatus === "OVERRIDE") {
    return true;
  }
  if (isTollFree(phoneNumber)) {
    return isTollfreeVerified(phoneNumber);
  }
  return phoneNumber.a2pEnrollmentStatus === "ENROLLED" && orgApproved;
}
